module.exports = __webpack_public_path__ + "img/works_rakuten_gora_4.e9fedaa4.png";